import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "./../../components/panel/panel.jsx";
import { UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { getSupervisors, deleteSupervisor } from "./../../services/supervisors";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "../../common/pagination";
import { paginate } from "../../utils/paginate";
import SupervisorsTable from "../../components/supervisorsTable.jsx";
import SearchBox from "./../../common/searchBox";
import _ from "lodash";
import http from "./../../services/httpService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Icons imports
import newIcon from "../../assets/Icons/new.svg";
import editIcon from "../../assets/Icons/edit.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import csvIcon from "../../assets/Icons/csv.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import Icon from "./../../common/icon";

const apiUrl = process.env.REACT_APP_API_URL;

class SupervisorsTableData extends Component {
	constructor(props) {
		super(props);
		this.state = {
			supervisors: [],
			pageSize: 10,
			currentPage: 1,
			sortColumn: { path: "companies.username", order: "asc" },
			searchQuery: "",
			checkedFields: [],
			errors: {},
		};
		this.handleDelete = this.handleDelete.bind(this);
		this.handleMassDelete = this.handleMassDelete.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
	}

	async componentDidMount() {
		document.title = "Supervisors";		
		const { data } = await getSupervisors();
		this.setState({ supervisors: data });
	}

	handleDelete = async (supervisor) => {
		///delete
		const originalSupervisors = this.state.supervisors;
		const supervisors = this.state.supervisors.filter((s) => s._id !== supervisor._id);
		this.setState({ supervisors });
		try {
			await http.delete(apiUrl + "/supervisors/" + supervisor._id);
		} catch (ex) {
			if (ex.response && ex.response === 404) {
				alert("already deleted");
			}
			this.setState({ supervisors: originalSupervisors });
		}
	};

	handleMassDelete = async (checkedFields) => {
		if (checkedFields.length === 0) {
			toast.warning("Please select items to delete.");
			return;
		}

		// Show confirmation dialog
		const confirmDelete = window.confirm(`Are you sure you want to delete ${checkedFields.length} supervisor record(s)?`);
		if (!confirmDelete) {
			return;
		}

		try {
			for (let i = 0; i < checkedFields.length; i++) {
				await http.delete(apiUrl + "/supervisors/" + checkedFields[i]);
				const supervisors = this.state.supervisors.filter(
					(s) => s._id !== checkedFields[i]
				);
				this.setState({ supervisors });
			}
			
			// Clear checked fields after deletion
			this.setState({ checkedFields: [] });
			toast.success(`${checkedFields.length} supervisor record(s) deleted successfully!`);
		} catch (error) {
			console.error("Error deleting supervisor records:", error);
			if (error.response && error.response.status === 404) {
				toast.error("Some supervisors were already deleted.");
			} else {
				toast.error("Failed to delete supervisor records.");
			}
		}
	};

	//check box change
	handleCheckboxChange = ({ target: { checked, value } }) => {
		if (checked) {
			const checkedFields = [...this.state.checkedFields, value];
			this.setState({ checkedFields });
		} else {
			const checkedFields = [...this.state.checkedFields];
			this.setState({ checkedFields: checkedFields.filter((e) => e !== value) });
		}
	};

	// Handle select all functionality
	handleSelectAll = (allIds) => {
		this.setState({ checkedFields: allIds });
	};

	//sorting columns
	handleSort = (sortColumn) => {
		this.setState({ sortColumn });
	};
	
	handlePageChange = (page) => {
		this.setState({ currentPage: page });
	};

	handleSearch = (query) => {
		this.setState({ searchQuery: query, currentPage: 1 });
	};

	getDataPgnation = () => {
		const {
			pageSize,
			currentPage,
			supervisors: Supervisors,
			sortColumn,
			searchQuery,
		} = this.state;
		
		let filtered = Supervisors;
		if (searchQuery) {
			filtered = Supervisors.filter(
				(supervisor) => {
					// Access nested operator data
					console.log(supervisor, "Sipervisor.search")
					const supervisorData = supervisor || {};
					const email = supervisorData.email || '';
					const username = supervisorData?.supervisors?.username || '';
					const firstName = supervisorData?.supervisors?.contactName?.first || '';
					const lastName = supervisorData.supervisors?.contactName?.last || '';
					console.log(email,username, firstName, lastName)
					// const businessName = supervisor.companyInfo?.businessName || '';

					return email.toLowerCase().includes(searchQuery.toLowerCase()) ||
						username.toLowerCase().includes(searchQuery.toLowerCase()) ||
						firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
						lastName.toLowerCase().includes(searchQuery.toLowerCase())
						//  ||
						// businessName.toLowerCase().includes(searchQuery.toLowerCase());
				}
			);
		}

		const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
		const supervisors = paginate(sorted, currentPage, pageSize);
		return { data: supervisors };
	};

	render() {
		const { length: count } = this.state.supervisors;
		const { pageSize, currentPage, sortColumn, searchQuery, checkedFields } = this.state;

		const { data: supervisors } = this.getDataPgnation();

		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item">
						<Link to="/">Home</Link>
					</li>
					<li className="breadcrumb-item">
						<Link to="/">Tables</Link>
					</li>
					<li className="breadcrumb-item active">Supervisors Table</li>
				</ol>
				<h1 className="page-header">Supervisors </h1>
				<Panel>
					<PanelHeader>Supervisors Management</PanelHeader>

					<React.Fragment>
						<ToastContainer />
						<div className="toolbar" style={toolbarStyles}>
							<Icon
								to="/user/supervisors/new"
								title="add supervisor"
								btnStyle={btnStyles}
								iconStyle={iconStyles}
								icon={newIcon}
							/>

							<button
								className="btn btn-default m-r-5 m-b-5"
								title="Edit Supervisor"
								style={btnStyles}
								disabled={checkedFields.length !== 1}
							>
								<Link
									to={
										checkedFields.length === 1
											? `/user/supervisors/${checkedFields[0]}`
											: "#"
									}
								>
									<img style={iconStyles} src={editIcon} alt="Edit Icon" />
								</Link>
							</button>

							<button
								className="btn btn-default m-r-5 m-b-5"
								title="Delete Supervisor"
								style={btnStyles}
								disabled={checkedFields.length === 0}
								onClick={() =>
									this.handleMassDelete(checkedFields)
								}
							>
								<img style={iconStyles} src={trashIcon} alt="Delete Icon" />
							</button>
							
							<Icon
								to="/user/supervisors/"
								title="Excel"
								btnStyle={btnStyles}
								iconStyle={iconStyles}
								icon={xlsIcon}
							/>
							
							<Icon
								to="/user/supervisors/"
								title="CSV"
								btnStyle={btnStyles}
								iconStyle={iconStyles}
								icon={csvIcon}
							/>
							
							<Icon
								to="/user/supervisors/"
								title="PDF"
								btnStyle={btnStyles}
								iconStyle={iconStyles}
								icon={pdfIcon}
							/>
						</div>
						
						<div className="table-responsive">
							<SearchBox value={searchQuery} onChange={this.handleSearch} />
							<p
								className="page-header float-xl-left"
								style={
									({ marginBottom: 5 }, { marginLeft: 20 }, { marginTop: 5 })
								}
							>
								{count} entries
							</p>

							<SupervisorsTable
								supervisors={supervisors}
								onDelete={this.handleDelete}
								onSort={this.handleSort}
								sortColumn={sortColumn}
								handleCheckboxChange={this.handleCheckboxChange}
								onSelectAll={this.handleSelectAll}
								checkedFields={checkedFields}
							/>
						</div>
					</React.Fragment>

					<hr className="m-0" />
					<PanelBody>
						<div className="d-flex align-items-center justify-content-center">
							<Pagination
								itemsCount={count}
								pageSize={pageSize}
								onPageChange={this.handlePageChange}
								currentPage={currentPage}
							/>
						</div>
					</PanelBody>
				</Panel>
			</div>
		);
	}
}

const toolbarStyles = {
	background: "#c8e9f3",
	padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
	width: "25px",
	height: "25px",
	marginRight: "0rem",
};

export default SupervisorsTableData;
